import { useEffect, useMemo, useState } from 'react';
import { Icon, LinearProgress, TablePagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Button, Typography, AlertColor } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LogChaveValorService } from 'shared/services/chaveValor/LogchaveValorService ';
import { IListagemLogChaveValor } from 'shared/types';
import { FerramentasDaListagem, IListaFiltros, AlertaSnackBar } from 'shared/components';
import { LayoutBaseDePagina } from 'shared/layouts';
import { useHasPermissionAcao } from 'shared/hooks';
import { currentDateHour, dateToLocalISO, stringToDateTime} from 'shared/utils';
import { useSelectedOrganization } from 'shared/store/organization';
import { DateTimePicker } from '@mui/x-date-pickers';



export const ListagemLogsChaveValor: React.FC = () => {  
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const org = useSelectedOrganization();
 
  
  const hasPermitionCreate = useHasPermissionAcao('organizacao','CRE');
  const hasPermitionRead = useHasPermissionAcao('organizacao','REA');
 

  const [stateSnack, setStateSnack] = useState({
    open: false,
    severity: 'success',
    message: '',
  });

  const [rows, setRows] = useState<IListagemLogChaveValor[]>([]);

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const [eventoPesquisar, setEventoPesquisar] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const buscaNome = useMemo(() => {
    return searchParams.get('userName') || [];
  }, [searchParams]);

  const buscaCodigo= useMemo(() => {
    return searchParams.get('codigo') ||  [];
  }, [searchParams]);  
  
  
  const limit = useMemo(() => {
    return searchParams.get('limit') || '10';
  }, [searchParams]);

  const offSet = useMemo(() => {
    return searchParams.get('offset') || '0';
  }, [searchParams]);



  const listaFiltros: IListaFiltros[] = [
    {
      tipo: 'TextField',
      mapValue: [],
      label: t('pages.chaveValor.usuario'),
      textoBusca: buscaNome,
      handleTextoBusca: texto => { searchParams.set('userName', texto.toString()); setSearchParams(searchParams, { replace: true }); }
    },
    {
      tipo: 'TextField',
      mapValue: [],
      label: t('pages.chaveValor.codigo'),
      textoBusca: buscaCodigo,
      handleTextoBusca: texto => { searchParams.set('codigo', texto.toString()); setSearchParams(searchParams, { replace: true }); }
    },
  
   
  ];
  
  const handleCloseSnack = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setStateSnack({...stateSnack, open:false});
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
    searchParams.set('offset', (newPage * rowsPerPage).toString()); setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    searchParams.set('limit', event.target.value.toString()); 
    searchParams.set('offset', '0');
    setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  const handleLimpar = () => {
   
    const parametros: string[] = [];
    searchParams.forEach(function (value, key) {
      parametros.push(key);
    });
    parametros.map((item) => (
      searchParams.delete(item)
    ));
    setPage(0);
    searchParams.set('offset', '0'); setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  const handlePesquisar = () => {
    setPage(0);
    searchParams.set('offset', '0'); setSearchParams(searchParams, { replace: true });
    setEventoPesquisar(!eventoPesquisar);
  };

  useEffect(() => {
    //console.log();
   
    setIsLoading(true);
    LogChaveValorService.getAll(searchParams.toString())
      .then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {
          setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
        } else {
          
          setTotalCount(result.count);
          setRows(result.rows);
          //console.log(result);
          setRowsPerPage(Number.parseInt(limit.toString()));
          setPage(Number.parseInt(offSet.toString())/Number.parseInt(limit.toString()));
        }
      });
  }, [eventoPesquisar]);

  return(
    <>
      <LayoutBaseDePagina
        titulo={t('pages.chaveValor.logchavevalor')}
        drawerDeFiltros={
          <FerramentasDaListagem
            listaFiltros={listaFiltros}
            handlePesquisar={() => handlePesquisar()}
            handleLimpar={() => handleLimpar()}
          />
        }
      >

        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
          <Table stickyHeader > 
            <TableHead>
              <TableRow>
                <TableCell> {t('pages.chaveValor.usuario')}</TableCell>
                <TableCell> {t('pages.chaveValor.sistema')}</TableCell>
                <TableCell> {t('pages.chaveValor.codigo')}</TableCell>                            
                <TableCell>{t('pages.chaveValor.acao')}</TableCell>
                <TableCell> {t('pages.chaveValor.dhalt')}</TableCell>
              </TableRow>
            </TableHead>
            {!isLoading && (<TableBody>
              {rows.map((row) => (
                <TableRow key={row.Codigo}>                  
                  <TableCell>{row.UsuAlteracao}</TableCell>
                  <TableCell>{row.NomeSistema}</TableCell>
                  <TableCell>{row.Codigo}</TableCell>                
                  <TableCell>{row.Acao}</TableCell>
                  <TableCell>{stringToDateTime(row.DhAlteracao.toString())}</TableCell>
                </TableRow>
              ))}
            </TableBody>)}
                    
            {totalCount === 0 && !isLoading && (
              <caption>{t('global.listaVazia')}</caption>
            )}

            <TableFooter>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={10}>
                    <LinearProgress variant='indeterminate' />
                  </TableCell>
                </TableRow>
              )}
              {(!isLoading) && (
                <TableRow>
                  <TableCell colSpan={2}>
                    {hasPermitionCreate && (<Button
                      color='primary'
                      disableElevation
                      variant='outlined'
                      onClick={() => navigate('/configChaveValor/listagem')}
                      startIcon={<Icon>arrow_back</Icon>}
                    >
                      <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                        {t('components.actions.voltar')}
                      </Typography>
                    </Button>
                    )}
                  </TableCell>
                  <TableCell colSpan={8}>
                    <TablePagination
                      component="div"
                      labelDisplayedRows={({ from, to, count }) => `${from} - ${to} ${t('global.of')} ${count !== -1 ? count : `${t('global.moreThan')} ${to}`}`}
                      labelRowsPerPage={t('global.rowsPerPage')}
                      showFirstButton={true}
                      showLastButton={true}
                      page={page}
                      count={totalCount}
                      rowsPerPage={rowsPerPage}
                      rowsPerPageOptions={[5,8,10,20,50,100]}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    //onChange={(_, newPage) => setSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableFooter>
          </Table>
        </TableContainer>
      </LayoutBaseDePagina>
      <AlertaSnackBar 
        open={stateSnack.open} 
        severity={stateSnack.severity as AlertColor} 
        message={stateSnack.message} 
        handleClose={handleCloseSnack} 
      />
    </>
  );
};